import React from 'react'

import * as S from './styles';

type Props = React.LiHTMLAttributes<HTMLLIElement> & {
  iconName: string;
  linkTo?: string;
}

export const ProfileOptionsNavItem = React.forwardRef<HTMLLIElement, Props>(({ children, iconName, linkTo = '', ...props }: React.PropsWithChildren<Props>, forwardRef) => {
  const content = (
    <>
      <S.NavItemIcon icon={iconName} height="1.5rem" />
      <S.NavItemTitle>{children}</S.NavItemTitle>
    </>
  );

  const navItemContent = (
    <S.NavItem {...props} ref={forwardRef}>
      {content}
    </S.NavItem>
  );

  return linkTo ? (
    <S.StyledLink to={linkTo}>
      {navItemContent}
    </S.StyledLink>
  ) : (
    navItemContent
  );
})
